<template>
<div id="app" ref='appContent'>
  <router-view></router-view>
</div>
</template>

<script>
import Vue from 'vue'
var app=new Vue({
  name: 'app',
})

export default{
  data(){
    return{
      Lmurl:'http://bwapi.boyuancb.com:7000'
    }
  },
  mounted(){
    // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
    // window.onbeforeunload = function (e) {
    //   // this.clearCookie();
    //   var storage = window.localStorage; 
    //   storage.clear()
    //   this.clearCookie();
    // }
  }
}
</script>

<style scoped lang="less">
#app{
  height: 100%;
  width: 100%;
}
.appImg{
  width:100%;
  height:100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue